import { useEffect, useState } from "react";
import {  Grid, Typography } from "@mui/material"

import { iconStyle, cardStyle, butttonWithIcon, secondary_icon } from "../../styles/sharedStyles";
import { PlotsForm } from "../SubComponents/ManageModelsForm";
import { useRef } from "react";


export const ManageModels = () => {

    const pageHeader = {
        fontFamily: "DM Sans, sans-serif",
        fontSize: "24px",
        fontWeight: "bold",
        color: "rgb(27 37 75)",
        display: "flex"
    }

    const buuton1 = {
        // width: "100%",
        marginRight: "8px",
        backgroundColor: "#f6f6ff",
        fontSize: "15px",
        fontWeight: "bold",
        color: "#696cff",
        borderRadius: "10px",
        border: "3px solid #a1a3ff"
    }

    const childRef = useRef();

    const handleClearData = () => {
     

    }





    // const [showOrHide, setShowOrHide] = useState(false);

    // const showORhideProblemFormulation = () => {
    //     setShowOrHide(!showOrHide)
    // }

    return (
        <>
            <Grid container spacing={3}>
                <Grid size={10} sx={{
                    padding: "0px 16px", marginTop: "auto",
                    marginBottom: "auto"
                }}>
                    <Typography component="div" sx={pageHeader}><span>Manage Models</span>

                        {/* <Box sx={butttonWithIcon} onClick={showORhideProblemFormulation}> {showOrHide ? <DoNotDisturbOnOutlinedIcon sx={secondary_icon} /> : <AddCircleOutlineIcon sx={secondary_icon} />}</Box> */}
                    </Typography>

                </Grid>
               

            </Grid>
            <PlotsForm ref={childRef} />

        </>
    )
}